import { logError } from "Infrastructure/Utils/LoggingUtils";
import type { BackNavigationConfig } from "Navigation/types";
// biome-ignore lint/style/noRestrictedImports: We're creating our custom navigation here
import { type Location, useLocation, useNavigate } from "react-router-dom";

const getPreviousUrl = (
  { mode, url, fallbackUrl }: BackNavigationConfig,
  location: Location,
) => {
  if (mode === "staticUrl") {
    return url;
  }

  if (mode === "historyStack") {
    const previousLocation = location.state?.locationHistoryStack?.[0] || {};
    const previousPathname = previousLocation.pathname || "";
    const previousSearchParams = previousLocation.search || "";

    return `${previousPathname}${previousSearchParams}` || fallbackUrl || "";
  }
};

export const useGoBack = (config: BackNavigationConfig) => {
  const navigate = useNavigate();
  const location = useLocation();

  const previousUrl = getPreviousUrl(config, location);
  const canNavigateBack = config.mode !== "disabled" && !!previousUrl;

  const navigateBack = () => {
    if (!canNavigateBack) {
      return logError(new Error("Error while trying to navigate back."), {
        config,
        location,
      });
    }

    const currentHistoryStack = location.state?.locationHistoryStack || [];
    navigate(previousUrl, {
      state: {
        ...location.state,
        locationHistoryStack: currentHistoryStack.slice(1), // pop the latest location from the history
      },
    });
  };

  return { navigateBack, canNavigateBack };
};
